import { assignRole } from 'actions/api/admin'

export const createRoleAssignment = async (payload) => {
  const req = await assignRole(payload)
  return { type: 'CREATE_Role_ASSIGNMENT_SUCCESS', data: req }
}
